import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import HotelContactsService from '../../../../services/HotelContactsService'
import { excludeKeyFromObjectList, searchFirstObjectInList } from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import SelectInput from '../../../atoms/form/SelectInput/SelectInput'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './OnlineTravelAgentContact.scss'

class OnlineTravelAgentContact extends Component {

    constructor(props) {
        super(props)
        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)

        const user = getSessionItem(SessionConst.USER)

        const isHotelContact = user.isHotelContact

        if (!hotelCode || !hotelInfo) {
            // Go home
            this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
        }

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            continueFlow: this.props.history.location?.state?.continueFlow,
            initialValues: this.initialValues,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            showResetModal: false,
            showErrorModal: false,
            isHotelContact: isHotelContact
        }
    }

    initialValues = {
        firstName: '',
        lastName: '',
        title: '',
        type: FormConst.HOTEL_CONTACT_TYPE_ONLINE_TRAVEL_AGENT,
        phoneNumber: '',
        countryCode: '',
        areaCode: '',
        phoneNumberType: '',
        email: '',
        emailType: FormConst.VALUE_WORK,
        preferred: true
    }

    validationSchema = Yup.object().shape({
        firstName: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
        lastName: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
        title: Yup.string()
            .max(FormConst.MAX_LENGTH_TITLE, `Maximum ${FormConst.MAX_LENGTH_TITLE} characters`)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
        countryCode: Yup.string().test('Country code validation', function (val) {
            if ((!!this.parent.areaCode || !!this.parent.phoneNumber) && !val) {
                return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
            } else if (!this.parent.email && !val) {
                return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
            }
            return true
        }).matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .max(FormConst.MAX_LENGTH_COUNTRY_CODE, `Maximum ${FormConst.MAX_LENGTH_COUNTRY_CODE} digits`),
        areaCode: Yup.string().test('Area code validation', function (val) {
            if ((!!this.parent.countryCode || !!this.parent.phoneNumber) && !val) {
                return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
            } else if (!this.parent.email && !val) {
                return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
            }
            return true
        }).matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .max(FormConst.MAX_LENGTH_AREA_CODE, `Maximum ${FormConst.MAX_LENGTH_AREA_CODE} digits`),
        phoneNumber: Yup.string().test('Phone number validation', function (val) {
            if ((!!this.parent.areaCode || !!this.parent.countryCode) && !val) {
                return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
            } else if (!this.parent.email && !val) {
                return this.createError({ message: 'Phone or email required' })
            }
            return true
        }).matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .max(FormConst.MAX_LENGTH_PHONE_NUMBER, `Maximum ${FormConst.MAX_LENGTH_PHONE_NUMBER} digits`),
        phoneNumberType: Yup.string().when('phoneNumber', {
            is: (val) => val !== undefined && val !== '',
            then: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
        }),
        email: Yup.string()
            .matches(FormConst.EMAIL_PATTERN, 'Valid email required')
    })

    async componentDidMount() {
        let existingOnlineTravelAgentContact
        let otherContactEntries = []
        // Retrieve hotel contacts
        await HotelContactsService.getHotelContacts({ hotelCode: this.state.hotelCode })
            .then(response => {
                if (response?.contacts) {
                    const onlineTravelAgentContact = searchFirstObjectInList('type', FormConst.HOTEL_CONTACT_TYPE_ONLINE_TRAVEL_AGENT, response.contacts)
                    otherContactEntries = excludeKeyFromObjectList('type', FormConst.HOTEL_CONTACT_TYPE_ONLINE_TRAVEL_AGENT, response.contacts)
                    if (onlineTravelAgentContact) {
                        existingOnlineTravelAgentContact = {
                            ...onlineTravelAgentContact
                        }
                        if (existingOnlineTravelAgentContact.phoneNumbers && existingOnlineTravelAgentContact.phoneNumbers.length > 0) {
                            existingOnlineTravelAgentContact.countryCode = existingOnlineTravelAgentContact.phoneNumbers[0].countryCode
                            existingOnlineTravelAgentContact.areaCode = existingOnlineTravelAgentContact.phoneNumbers[0].areaCode
                            existingOnlineTravelAgentContact.phoneNumber = existingOnlineTravelAgentContact.phoneNumbers[0].number
                            existingOnlineTravelAgentContact.phoneNumberType = existingOnlineTravelAgentContact.phoneNumbers[0].type
                        } else {
                            existingOnlineTravelAgentContact.countryCode = ''
                            existingOnlineTravelAgentContact.areaCode = ''
                            existingOnlineTravelAgentContact.phoneNumber = ''
                            existingOnlineTravelAgentContact.phoneNumberType = ''
                        }

                        if (existingOnlineTravelAgentContact.emailAddresses && existingOnlineTravelAgentContact.emailAddresses.length > 0) {
                            existingOnlineTravelAgentContact.email = existingOnlineTravelAgentContact.emailAddresses[0].address
                            existingOnlineTravelAgentContact.emailType = existingOnlineTravelAgentContact.emailAddresses[0].type
                        } else {
                            existingOnlineTravelAgentContact.email = ''
                            existingOnlineTravelAgentContact.emailType = this.initialValues.emailType
                        }
                    }
                }
                this.setState({
                    isLoading: false,
                    onlineTravelAgentContact: existingOnlineTravelAgentContact,
                    otherContactEntries: otherContactEntries,
                    initialValues: existingOnlineTravelAgentContact ? existingOnlineTravelAgentContact : this.initialValues
                })
            }).catch(error => {
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    errorMessage: 'There was an error while retrieving Hotel Contacts data'
                })
            })
    }

    handleSubmit = (formData) => {
        const newEntry = { ...formData }
        newEntry.type = FormConst.HOTEL_CONTACT_TYPE_ONLINE_TRAVEL_AGENT
        delete newEntry["phoneNumbers"]
        delete newEntry["emailAddresses"]

        const newHotelContacts = [...this.state.otherContactEntries, newEntry]

        this.props.onPut({ hotelCode: this.state.hotelCode, formData: newHotelContacts })
        this.setState({ isLoading: true, loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT })
    }

    handleClearForm = () => {
        this.setState({ showResetModal: true })
    }

    resetFormData = (formikResetFormMethod) => {
        formikResetFormMethod()
        this.setState({
            showResetModal: false
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    errorMessage: this.props.errorDescription,
                })
            } else {
                // Continue to next form
                if (this.state.continueFlow) {
                    // Go to the next page
                    this.props.history.push({
                        pathname: RouteConst.ROUTE_EMERGENCY_CONTACTS_PAGE,
                        state: {
                            continueFlow: this.state.continueFlow
                        }
                    })
                } else {
                    // Go back to hotel contacts page
                    this.props.history.push(RouteConst.ROUTE_HOTEL_CONTACTS_PAGE)
                }
            }
            this.setState({ isLoading: false })
        }
    }

    handleErrorModalCancel = () => {
        this.setState({ isLoading: false })
    }

    render() {
        return (
            <Formik
                initialValues={this.state.initialValues}
                validationSchema={this.validationSchema}
                enableReinitialize={true}
                onSubmit={(data, { setSubmitting, resetForm }) => {
                    setSubmitting(true)
                    this.handleSubmit(data)
                    setSubmitting(false)
                }}>
                {
                    ({ isSubmitting, resetForm, handleChange }) => (
                        <Form className='online-travel-agent-contact-form-element'>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                                    <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOTEL_CONTACTS_PAGE}>Hotel Contacts</NavLink></li>
                                    <li className="breadcrumb-item active" aria-current="page">Hotel Contact</li>
                                </ol>
                            </nav>
                            <p className='hotel-contact-type'>OTA Contact</p>
                            <p className='form-helper-text'>Enter OTA Contact details. ** Phone number or Email is required.</p>

                            <div className='online-travel-agent-contact-form-fields'>
                                <TextInput id='firstName' name='firstName' type='text' label='First Name' isrequired='true' />
                                <TextInput id='lastName' name='lastName' type='text' label='Last Name' isrequired='true' />
                                <TextInput id='title' name='title' type='text' label='Title' />
                                <TextInput id='phone-number' name='countryCode' type='tel' label='Phone Number' isdependent='true'
                                    placeholder='CC'
                                    suffix={
                                        <>
                                            <TextInput id='area-code' name='areaCode' label=' - ' type='num' title='Area Code' placeholder='Area Code' />
                                            <TextInput name='phoneNumber' type='tel' label=' - ' title='Phone Number' placeholder='Phone Number' />
                                        </>
                                    } />
                                <SelectInput id='phoneNumberType' name='phoneNumberType' type='tel' label='Phone Number Type' isdependent='true'
                                    options={FormConst.HOTEL_CONTACTS_PHONE_NUMBER_TYPES} />
                                <TextInput
                                    id='email'
                                    name='email'
                                    type='email'
                                    label='Email'
                                    title='Email (lowercase)'
                                    onChange={(e) => {
                                        e.preventDefault()
                                        if (e.target.value) {
                                            e.target.value = e.target.value.toLowerCase()
                                        }
                                        handleChange(e)
                                    }}
                                    isdependent='true' />
                            </div>

                            <FormFooter
                                form={
                                    {
                                        previous: { title: !this.state.isHotelContact ? FormConst.LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR : FormConst.LABEL_HOTEL_CONTACT_TYPE_ONBOARDING_CONTACT, route: !this.state.isHotelContact ? RouteConst.ROUTE_OSD_CONTACT : RouteConst.ROUTE_ONBOARDING_CONTACT},
                                        next: { title: FormConst.LABEL_HOTEL_CONTACT_TYPE_EMERGENCY_CONTACTS, route: RouteConst.ROUTE_EMERGENCY_CONTACTS_PAGE }
                                    }
                                }
                                isSubmit
                                submitName={FormConst.SAVE_BUTTON_TEXT}
                                resetName={FormConst.RESET_BUTTON_TEXT}
                                onReset={this.handleClearForm}
                                submitDisabled={isSubmitting} />
                            <FormModal
                                id='hotel-contacts-page-loading-modal'
                                title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                hotelInfo={this.state.hotelInfo}
                                body={<h5>{this.state.loadingMessage}</h5>}
                                show={this.state.isLoading}
                                isLoadingIndicator />
                            <FormModal
                                id='hotel-contacts-page-reset-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_RESET_ACTION_TITLE}
                                body={<h5>{FormConst.MODAL_RESET_ACTION_TEXT}</h5>}
                                proceed={() => {
                                    this.resetFormData(resetForm)
                                }}
                                cancel={() => { this.setState({ showResetModal: false }) }}
                                show={this.state.showResetModal} />
                            <FormModal
                                id='hotel-contacts-page-error-modal'
                                title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                hotelInfo={this.state.hotelInfo}
                                body={<h5>{this.state.errorMessage}</h5>}
                                isError
                                show={this.state.showErrorModal}
                                cancel={() => this.props.history.push(RouteConst.ROUTE_HOTEL_CONTACTS_PAGE)} />
                        </Form>
                    )
                }
            </Formik>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        hotelContactsResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_HOTEL_CONTACTS_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(OnlineTravelAgentContact, SideNavEntryMapping.CONTACTS))